import { number, object, string } from 'yup'

import type { CreateObjectRulesStepResponse } from 'shared/api/kyrgyzstan/create-object'
import { createYupFormResolver } from 'shared/lib/form'

export interface CreateObjectConditionsFormValues {
  arrivalTimeFrom: string
  arrivalTimeTo: string
  departureTimeBefore: string
  freeCancellationMinutes: number | null
  homeRulesText: string
}

export const CREATE_OBJECT_CONDITIONS_TEXT_MAX_LENGTH = 256

export const createObjectConditionsFormDefaultValues: CreateObjectConditionsFormValues =
  {
    arrivalTimeFrom: '',
    arrivalTimeTo: '',
    departureTimeBefore: '',
    freeCancellationMinutes: null,
    homeRulesText: '',
  }

const requiredFieldMessage = ''
const timeFieldRegExp = /^([01]\d|2[0-3]):[0-5]\d$/
const validateTimeField = (value?: string): boolean =>
  !value || timeFieldRegExp.test(value)

const createObjectConditionsFormSchema = object({
  arrivalTimeFrom: string()
    .trim()
    .required(requiredFieldMessage)
    .test('time-format', requiredFieldMessage, validateTimeField),
  arrivalTimeTo: string()
    .trim()
    .required(requiredFieldMessage)
    .test('time-format', requiredFieldMessage, validateTimeField),
  departureTimeBefore: string()
    .trim()
    .required(requiredFieldMessage)
    .test('time-format', requiredFieldMessage, validateTimeField),
  freeCancellationMinutes: number()
    .nullable()
    .test(
      'required-cancellation',
      requiredFieldMessage,
      (value) => value !== null && value !== undefined,
    ),
  homeRulesText: string().trim().max(CREATE_OBJECT_CONDITIONS_TEXT_MAX_LENGTH),
})

export const createObjectConditionsFormResolver =
  createYupFormResolver<CreateObjectConditionsFormValues>(
    createObjectConditionsFormSchema,
  )

export const mapCreateObjectRulesResponseToFormValues = ({
  arrival_time_from: arrivalTimeFrom,
  arrival_time_to: arrivalTimeTo,
  departure_time_before: departureTimeBefore,
  free_cancellation_minutes: freeCancellationMinutes,
  home_rules_text: homeRulesText,
}: CreateObjectRulesStepResponse): CreateObjectConditionsFormValues => ({
  arrivalTimeFrom: arrivalTimeFrom || '',
  arrivalTimeTo: arrivalTimeTo || '',
  departureTimeBefore: departureTimeBefore || '',
  freeCancellationMinutes: freeCancellationMinutes ?? null,
  homeRulesText: homeRulesText || '',
})
